"use client";

import { useState } from "react";
import {
    BotIcon,
    ChevronDownIcon,
    ChevronRightIcon,
    Clock,
    Sparkles
} from "lucide-react";
import { Button } from "ui/button";
import { Badge } from "ui/badge";
import {
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger,
} from "ui/collapsible";

export function AgentsSidebarSection() {
    const [isExpanded, setIsExpanded] = useState(true);

    return (
        <div className="space-y-1">
            <Collapsible open={isExpanded} onOpenChange={setIsExpanded}>
                <div className="flex items-center justify-between">
                    <CollapsibleTrigger asChild>
                        <Button
                            variant="ghost"
                            className="w-full justify-start font-medium text-sm h-8 px-2"
                        >
                            {isExpanded ? (
                                <ChevronDownIcon className="size-4 mr-2" />
                            ) : (
                                <ChevronRightIcon className="size-4 mr-2" />
                            )}
                            <BotIcon className="size-4 mr-2" />
                            Agents
                            <Badge variant="secondary" className="ml-auto text-xs flex items-center gap-1">
                                <Clock className="size-2" />
                                Coming Soon
                            </Badge>
                        </Button>
                    </CollapsibleTrigger>
                </div>

                <CollapsibleContent className="space-y-1">
                    <div className="px-4 py-3 text-xs text-muted-foreground bg-muted/30 rounded-md mx-2">
                        <div className="flex items-center gap-2 mb-1">
                            <Sparkles className="size-3" />
                            <span className="font-medium">AI Agents Coming Soon</span>
                        </div>
                        <p className="text-[10px] leading-relaxed">
                            We're training specialized AI agents to provide you with enhanced capabilities.
                            This feature will be available soon!
                        </p>
                    </div>
                </CollapsibleContent>
            </Collapsible>
        </div>
    );
}